module.exports = "<p>\r\n  effective-permissions-entity-types works!\r\n</p>\r\n"